/**
 * This is a directive to store data in a local variable
 * I developped it from angular's ngIf directive.
 * https://github.com/angular/angular/blob/6.1.1/packages/common/src/directives/ng_if.ts
 *
 * ## Storing result in a variable
 *
 * A common pattern is that we need to show a set of properties from the same object. If the
 * object is undefined, then we have to use the safe-traversal-operator `?.` to guard against
 * dereferencing a `null` value. This is especially the case when waiting on async data such as
 * when using the `async` pipe as shown in following example:
 *
 * ```
 * Hello {{ (userStream|async)?.last }}, {{ (userStream|async)?.first }}!
 * ```
 * There are several inefficiencies in the above example:
 *  - We create multiple subscriptions on `userStream`. One for each `async` pipe, or two in the
 *    example above.
 *  - We have to use the safe-traversal-operator `?.` to access properties, which is cumbersome.
 *  - We have to place the `async` pipe in parenthesis.
 *
 * A better way to do this is to use `ngIf` and store the result of the condition in a local
 */

import {
  Directive, EmbeddedViewRef,
  Input, NgModule,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';


export class NgLetDirective {
  private _context: NgLetContext = new NgLetContext();
  private _thenTemplateRef: TemplateRef<NgLetContext> | null = null;
  private _thenViewRef: EmbeddedViewRef<NgLetContext> | null = null;

  constructor(
    private _viewContainer: ViewContainerRef,
    templateRef: TemplateRef<NgLetContext>) {
      this._thenTemplateRef = templateRef;
  }

  
  set ngLet(condition: any) {
    this._context.$implicit = this._context.ngLet = condition;
    this._updateView();
  }

  private _updateView() {
    if (!this._thenViewRef) {
      this._viewContainer.clear();
      if (this._thenTemplateRef) {
        this._thenViewRef =
          this._viewContainer.createEmbeddedView(
            this._thenTemplateRef, this._context
          );
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngLet]'}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: TemplateRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngLet': [{ type: Input },],
};
}

export class NgLetContext {
  public $implicit: any = null;
  public ngLet: any = null;
}




export class NgLetModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [NgLetDirective],
  exports: [NgLetDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
